import { VersionComponent } from './pages/version/version.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AuthGuard } from '@core/auth/auth.guard';
import { ProfileComponent } from './pages/profile/profile.component';
import { NotFoundComponent } from './pages/404/notfound.component';
import { UnAuthorizedComponent } from './pages/401/unauthorized.component';
import { CourseSearchComponent } from './modules/search/pages/course-search.component';
const routes: Routes = [
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard]
  },
  {
    path: '', component: HomeComponent,
  },   
  {
    path: 'student-search',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/search/search.module').then(m => m.SearchModule)   
  },
  {
    path: 'course-search', component: CourseSearchComponent,
  },  
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'maintenance',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/maintenance/maintenance.module').then(m => m.MaintenanceModule),
  },
  {
    path: 'compliance/:mode',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/compliance/compliance.module').then(m => m.ComplianceModule)   
  },
  {
    path: 'compliance',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/compliance/compliance.module').then(m => m.ComplianceModule)   
  },
  {
    path: 'prospective',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/prospective/prospective.module').then(m => m.ProspectiveModule)   
  },
  {
    path: 'certification/:mode',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/certification/certification.module').then(m => m.CertificationModule)   
  },
  {
    path: 'certification',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/certification/certification.module').then(m => m.CertificationModule)   
  },
  {
    path: 'financialaid',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/financialaid/financialaid.module').then(m => m.FinancialAidModule)   
  },
  {
    path: 'summary',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/summary/summary.module').then(m => m.SummaryModule)   
  },
  {
    path: 'apr',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/apr/apr.module').then(m => m.AprModule)  
  },
  {
    path: 'reports',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule)   
  },
  { path: 'version', component: VersionComponent },
  { path: '404', component: NotFoundComponent },
  { path: '401', component: UnAuthorizedComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
